import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  link: {
    color: '#000',
  },
  palette: {
    primary: {
      main: '#252d55',
    },
    secondary: {
      main: '#ecb82b',
    },
    background: {
      default: '#fff',
      sidebar: '#11161a',
      header: '#191b27',
    },
    text: {
      primary: '#151515',
      secondary: '#68a1ac',
      error: red.A400,
    },
  },
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ['Roboto'].join(','),
    fontSize: 14,
  },
});

export default theme;
